import { getDownloadURL, ref } from "firebase/storage";
import { storageRef } from "../../auth/FirebaseContext";

export async function getProductImage(uid) {
  const imageRef = ref(ref(storageRef, `/public/saleProductsImages`), uid);
  return await getDownloadURL(imageRef);
}